// extracted by mini-css-extract-plugin
module.exports = {"primary":"Button_primary__I_9I9","secondary":"Button_secondary__1gv5E","link":"Button_link__Kr8EU"};